import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { maxDateValidator } from '@mynexus/mynexus-ui-lib';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'date-time-modal',
    templateUrl: './date-time-modal.component.html',
    styleUrls: ['./date-time-modal.component.scss'],
    standalone: false
})
export class DateTimeModalComponent {
  maxDate = new Date();
  dateTimeFaxReceived = new FormControl(null, [Validators.required, maxDateValidator]);

  constructor(public ref: DynamicDialogRef) { }

  onClose() {
    this.ref.close(this.dateTimeFaxReceived.value);
  }
}
